var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 167,
    viewBox: "0 0 198 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vi with stroke and shadow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape",
    filter: "url(#filter0_bd_9866_199282)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 68C31 105.555 61.4446 136 99 136C136.555 136 167 105.555 167 68H31Z",
    fill: "white",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    filter: "url(#filter1_b_9866_199282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 68,
    r: 68,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/vi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/vi_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0993 128.252C132.317 128.252 159.246 101.322 159.246 68.1025C159.246 34.8829 132.317 7.95312 99.0993 7.95312C65.8814 7.95312 38.9531 34.8829 38.9531 68.1025C38.9531 101.322 65.8814 128.252 99.0993 128.252Z",
    fill: "#20662E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0737 88.4695L130.983 50.8179C132.076 49.8364 132.083 48.2386 130.999 47.2491L129.037 45.4572C127.953 44.4677 126.189 44.4615 125.096 45.443L87.143 79.5399L71.126 64.9166C70.0423 63.9271 68.2778 63.9208 67.1852 64.9023L65.2069 66.6796C64.1143 67.6611 64.1073 69.2589 65.191 70.2484L85.1329 88.4551C86.2166 89.4446 87.9811 89.451 89.0737 88.4695Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_9866_199282",
    x: 0,
    y: 37,
    width: 198,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.29652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9866_199282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.4 0 0 0 0 0.180392 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_9866_199282",
    result: "effect2_dropShadow_9866_199282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9866_199282",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9866_199282",
    x: 12.407,
    y: -18.593,
    width: 173.186,
    height: 173.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.29652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9866_199282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9866_199282",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/Vi.710c62ac67116e0c08625af4f0b541d7.svg";
export { ForwardRef as ReactComponent };